var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    _vm._l(_vm.categories, function (category) {
      return _c("li", { key: category.term_id }, [
        _c(
          "a",
          {
            attrs: { href: _vm.slug(category) },
            on: {
              click: function ($event) {
                return _vm.setCategory(category)
              },
            },
          },
          [_vm._v(_vm._s(category.name))]
        ),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/FaqSidebar.vue